import { render } from "./CookieLaw.vue?vue&type=template&id=6ffa83d3"
import script from "./CookieLaw.vue?vue&type=script&lang=js"
export * from "./CookieLaw.vue?vue&type=script&lang=js"

import "./CookieLaw.vue?vue&type=style&index=0&id=6ffa83d3&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__